import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Itineraire from "./views/Itineraire.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        title: "Horaires Tram & Bus Clermont-Ferrand",
        content:
          "T2C.app est une application permettant de consulter pour les horaires des transports en commun (tram et bus) de Clermont-Ferrand."
      }
    },
    {
      path: "/settings",
      name: "settings",
      component: Home,
      meta: {
        title: "Horaires Tram & Bus Clermont-Ferrand",
        content:
          "T2C.app est une application permettant de consulter pour les horaires des transports en commun (tram et bus) de Clermont-Ferrand."
      }
    },
    {
      path: "/ligne/:ligne",
      name: "searchLigne",
      component: Home,
      meta: {
        title: "Horaires {:vehicule} Clermont-Ferrand",
        content:
          "Retrouve les horaires des {:vehicule} (ligne {:ligne}) sur t2c.app"
      }
    },
    {
      path: "/itineraire",
      name: "itineraire",
      component: Itineraire
    },
    {
      path: "/arret/:arret",
      name: "searchArret",
      component: Home,
      meta: {
        title: "Horaires à {:arret} Tram & Bus Clermont-Ferrand",
        content:
          "Retrouve les horaires à {:arret} de bus et de tram sur t2c.app"
      }
    },
    {
      path: "/:ligne/:arret/:direction",
      name: "shareHome",
      component: Home,
      meta: {
        title: "Horaires {:vehicule} {:arret} vers {:direction}",
        content:
          "Retrouve les horaires du {:vehicule} {:ligne} direction {:direction} sur t2c.app"
      }
    }
  ]
});

const replace = (str, { arret, ligne, direction }) =>
  str
    .replace("{:arret}", arret)
    .replace("{:ligne}", ligne)
    .replace("{:direction}", direction)
    .replace("{:vehicule}", ligne === "A" ? "tram" : "bus");
router.beforeEach((to, from, next) => {
  try {
    const { ligne, arret, direction } = to.params || {
      ligne: null,
      arret: null,
      direction: null
    };

    // Meta title
    document.title = replace(to.meta.title, { ligne, arret, direction });

    // Meta descriptions
    const content = replace(to.meta.content, { ligne, arret, direction });

    document
      .querySelector('meta[name="description"]')
      .setAttribute("content", content);
    document
      .querySelector('meta[property="og:description"]')
      .setAttribute("content", content);
  } catch (e) {
    console.log(e);
  }

  next();
});

export default router;
